import { render, staticRenderFns } from "./ShippingStatusModal.vue?vue&type=template&id=fa3547bc"
import script from "./ShippingStatusModal.vue?vue&type=script&lang=js"
export * from "./ShippingStatusModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports